module.exports = __webpack_public_path__ + "static/media/rocky-1.a3cc9784.jpeg";